module.exports = __webpack_public_path__ + "static/media/icon-billing-grey.48cbb658.svg";